export enum alignment {
    left = 'left',
    center = 'center',
    right = 'right',
}